let privacy = {
  top: {
    title_1: "将您的隐私放在首位的",
    title_2: "VPN应用程序",
    explain: "我们的应用程序旨在保护您的互联网连接安全和隐私，"
      + " 防止您的ISP和政府监视您以及您访问的网站识别和跟踪您，"
      + " 旨在击败审查制度，为所有人提供免费开放的互联网。",
  },
  download_btn: "下载 Rabbit VPN",
  introduce: {
    control: {
      title: "你有控制权",
      explain: "您拥有绝对的控制权，包括在任何时候选择退出交易所，"
        + "何时从您的设备使用网络，以及选择允许您使用的内容和可以访问的网站。",
    },
    data_security: {
      title: "数据安全",
      explain: "Rabbit VPN使用最新的加密技术保护您的数据流量免受间谍攻击。"
        + "它也不会跟踪或存储您的浏览历史记录、流量目的地、数据内容或DNS查询的日志，"
        + "确保没有人可以访问您的数据和信息。"
    },
    privacy_security: {
      title: "隐私安全",
      explain: "Rabbit VPN不需要您的任何个人数据，也不需要信用卡或电子邮件地址，"
          + "我们严格遵守所有相关数据保护法律要求，包括新的欧盟数据保护监管框架-GDPR"
          + "和2018年加利福尼亚消费者隐私法-CCPA。我们知道您的IP地址，就像任何其他VPN一样，"
          + "但Rabbit VPN将在您的设备可用时支付您访问网络的服务费用。"
    },
    manual_security: {
      title: "手动维修",
      explain: "还有其他问题吗？我们的团队可以在7*24小时内解决您遇到的任何问题。您可以随时与我们联系。"
    }
  }
}
export default privacy


// WEBPACK FOOTER //
// ./src/assets/lang/zh/new_privacy/index.js